import { render, staticRenderFns } from "./InvestmentForm.vue?vue&type=template&id=6b0b4b6e&scoped=true&"
import script from "./InvestmentForm.vue?vue&type=script&lang=js&"
export * from "./InvestmentForm.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentForm.vue?vue&type=style&index=0&id=6b0b4b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b4b6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VForm,VProgressCircular,VSelect,VSpacer,VTextField})
